import React from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, FormFeedback, Input, Button, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const NewDiscountCodeModal = ({ isOpen, toggle, onSave, discountCode, onInputChange, errors = {} }) => {
    let parsedDate = null;
    if (discountCode.expires_at && moment(discountCode.expires_at).isValid()) {
       parsedDate = moment(discountCode.expires_at);
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} autoFocus={false}>
            <ModalHeader toggle={toggle}>New Discount Code</ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => { e.preventDefault(); onSave(discountCode); }}>
                    {errors.non_field_errors && (
                        <div className="alert alert-danger">
                            {errors.non_field_errors.map((msg, i) => <div key={i}>{msg}</div>)}
                        </div>
                    )}
                    <FormGroup>
                        <Label for="code">Code</Label>
                        <Input
                            type="text"
                            name="code"
                            id="code"
                            value={discountCode.code}
                            onChange={(e) => onInputChange('code', e.target.value)}
                            placeholder="Discount code"
                            required
                            autoFocus={true}
                            invalid={!!errors.code}
                        />
                        {errors.code && errors.code.map((msg, i) => <FormFeedback key={i}>{msg}</FormFeedback>)}
                    </FormGroup>

                    <FormGroup>
                        <Label for="discountAmount">Discount Amount</Label>
                        <Input
                            type="text"
                            placeholder="Enter dollar amount"
                            name="discountAmount"
                            id="discountAmount"
                            value={discountCode.discount_amount}
                            onChange={(e) => onInputChange('discount_amount', e.target.value)}
                            required
                            invalid={!!errors.discount_amount || !/^\d*\.?\d{0,2}$/.test(discountCode.discount_amount)}
                        />
                        {errors.discount_amount
                            ? errors.discount_amount.map((msg, i) => <FormFeedback key={i}>{msg}</FormFeedback>)
                            : <FormFeedback>Enter a valid dollar amount (up to 2 decimal places).</FormFeedback>}
                    </FormGroup>

                    <FormGroup>
                        <Label for="expiresAt">Expires</Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <DatePicker 
                                id="expiresAt"
                                name="expiresAt"
                                className="form-control"
                                selected={parsedDate ? parsedDate.toDate() : ''}
                                onChange={(date) => onInputChange('expires_at', date)}
                                dateFormat="MM/dd/yyyy"
                                style={{ marginLeft: '10px' }} 
                            />
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <Label for="description">Description</Label>
                        <Input
                            type="text"
                            name="description"
                            id="description"
                            value={discountCode.description}
                            onChange={(e) => onInputChange('description', e.target.value)}
                            invalid={!!errors.description}
                        />
                        {errors.description && errors.description.map((msg, i) => <FormFeedback key={i}>{msg}</FormFeedback>)}
                    </FormGroup>

                    <Button color="primary" type="submit">Save</Button>{' '}
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default NewDiscountCodeModal;
